import { create } from "zustand";

export type AppRoute = "landing" | "login" | "platform" | "docs" | "forgot-password";

const VALID_ROUTES: AppRoute[] = ["landing", "login", "platform", "docs", "forgot-password"];

function readRouteFromHash(): AppRoute {
  const hash = window.location.hash.replace("#", "") as AppRoute;
  return VALID_ROUTES.includes(hash) ? hash : "landing";
}

function writeRouteToHash(route: AppRoute) {
  window.location.hash = route === "landing" ? "" : route;
}

interface RouterState {
  route: AppRoute;
  navigate: (route: AppRoute) => void;
}

export const useRouter = create<RouterState>(set => {
  const initial = readRouteFromHash();

  window.addEventListener("hashchange", () => {
    const next = readRouteFromHash();
    set({ route: next });
  });

  return {
    route: initial,
    navigate: (route: AppRoute) => {
      writeRouteToHash(route);
      set({ route });
    },
  };
});
